import React, { SVGProps } from 'react';

export const CaretLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.55 19.006 7.5 12l7.05-7.006 1.26 1.276L10.096 12l5.714 5.73z"
    />
  </svg>
);
